<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  export default {
    name: 'AttachmentItem',
    props: {
      attachment: Object,
    },
    computed: {
      isImage() {
        return this.attachment.type && this.attachment.type.indexOf('image') > -1
      },
      mimeType() {
        return this.attachment.link && this.attachment.link.split('.').pop()
      },
    },
    methods: {
      removeFile() {
        this.$emit('onRemove', this.attachment.id)
      },
    },
  }
</script>
